import "./styles/main.scss"
import App from "./scripts/App"
import { NavigationProvider } from "./scripts/NavigationContext"
import { BrowserRouter } from 'react-router-dom'
import React from "react"
import ReactDOM from "react-dom/client"

const root = ReactDOM.createRoot(document.querySelector("#app"))
root.render(
  <BrowserRouter>
    <NavigationProvider>
      <App />
    </NavigationProvider>
  </BrowserRouter>
)